import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, Observable } from 'rxjs';
import { CommonService } from '../../common-service';
import { Router } from '@angular/router';
import { ReturnStruct } from 'src/app/shared/structs/return.struct';
import { AppConfigService } from 'src/app/app-config.service';
import { EndpointBuilderService } from 'src/app/shared/services/endpint-builder.service';
import { ApiEnum } from 'src/app/shared/enum/api.enum';
import { ListDataProductResponse } from '../../responses/data-mesh/list-data-product.response';
import { DataProductResponse } from '../../responses/data-mesh/data-product.response';
import { DataProductCreateRequest } from '../../requests/data-mesh/data-product-create.request';
import { DataProductUpdateRequest } from '../../requests/data-mesh/data-product-update.request';

@Injectable({
    providedIn: 'root'
})
export class DataProductService extends CommonService {
    private apiUrl = 'https://api.example.com/data-products';

    constructor(private router: Router, private httpClient: HttpClient, configService: AppConfigService, private endpointBuilder: EndpointBuilderService) {
        super(configService);
    }

    getAllDataProducts(): Observable<ListDataProductResponse> {
        let uri = `data-product/get-all`;
        return this.httpClient.get<ListDataProductResponse>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiDataMesh) + uri, this.addHeaderToken())
            .pipe(
                catchError(this.handleError)
            );
    }

    getDataProductById(id: number): Observable<DataProductResponse> {
        let uri = `data-product/get/${id}`;
        return this.httpClient.get<DataProductResponse>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiDataMesh) + uri, this.addHeaderToken())
            .pipe(
                catchError(this.handleError)
            );
    }

    createDataProduct(request: DataProductCreateRequest): Observable<ReturnStruct> {
        let uri = `data-product/create`;
        return this.httpClient.post<ReturnStruct>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiDataMesh) + uri, request, this.addHeaderToken())
            .pipe(
                catchError(this.handleError)
            );
    }

    updateDataProduct(request: DataProductUpdateRequest): Observable<ReturnStruct> {
        let uri = `data-product/update`;
        return this.httpClient.post<ReturnStruct>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiDataMesh) + uri, request, this.addHeaderToken())
            .pipe(
                catchError(this.handleError)
            );
    }

    deleteDataProduct(id: number): Observable<ReturnStruct> {
        let uri = `data-product/delete/${id}`;
        return this.httpClient.delete<ReturnStruct>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiDataMesh) + uri, this.addHeaderToken())
            .pipe(
                catchError(this.handleError)
            );
    }
}